import { api } from './client.js';

/** 별채대화. before 를 주면 그보다 앞의 말 (DEV_SPEC 6장 GET /api/room) */
export function fetchRoom({ before, signal } = {}) {
    const query = before ? `?before=${before}` : '';
    return api(`/room${query}`, { signal });
}

/** 폴링: afterId 보다 뒤의 말과 입력 중 멤버 */
export function fetchRoomPending(afterId, { signal } = {}) {
    return api(`/room/pending?after=${afterId}`, { signal, timeoutMs: 10000 });
}

/** 같은 말을 다시 보낼 때는 같은 clientKey 를 씁니다(서버가 한 번만 저장) */
export function postRoomMessage({ body, clientKey, chipItemsId = null }) {
    // 대화 칩으로 보낸 말이면 그 칩 번호(서버가 주인 · 번호를 확인, C-29)
    const payload = chipItemsId ? { body, clientKey, chipItemsId } : { body, clientKey };
    return api('/room/messages', { method: 'POST', body: payload });
}

/** 입력 중 신호(C-28): 쓰기 시작 'start' · 비움 'end'. 키 입력은 보내지 않습니다. 실패해도 대화는 그대로 */
export function postRoomCompose(state) {
    return api('/room/compose', { method: 'POST', body: { state }, timeoutMs: 5000 });
}

export function answerRoomHook(roomMessagesId, { choice = null, clientKey = null } = {}) {
    return api(`/room/hooks/${roomMessagesId}/answer`, { method: 'POST', body: { choice, clientKey } });
}

export function postRoomWorry({ body, clientKey }) {
    return api('/room/worry', { method: 'POST', body: { body, clientKey } });
}

/** 별채가 3분 넘게 조용할 때 화제 던지기(C-25). 서버가 조건을 다시 보고, 던지면 { message } */
export function postRoomNudge() {
    return api('/room/nudge', { method: 'POST', body: {}, timeoutMs: 20000 });
}

/** 화면에 보인 마지막 말(떠날 때 · 30초마다, C-20b). 실패해도 대화는 그대로 */
export function postRoomSeen(roomMessagesId) {
    return api('/room/seen', { method: 'POST', body: { roomMessagesId }, timeoutMs: 5000 });
}

/** 2막 장면 칩을 30초 동안 안 눌렀을 때(서버가 한 번만 이모 소개 말로 넘김, C-21 · D76) */
export function postAnnexIdle() {
    return api('/room/annex-idle', { method: 'POST', body: {} });
}

/** 명함을 눌러 봤음(첫 주 차례의 단독 명함을 건너뜀, 16.4) */
export function markMemberCardSeen(memberKey) {
    return api('/me/member-cards/seen', { method: 'POST', body: { memberKey } });
}
